// 相关全部请求
import environment from '../../config/environment'
import {getListedCompanyListAPI} from '../api'
import {encrypt} from '../common'
import qs from 'qs'

// 常量
const API_CODE = environment.apiCode
const API_KEY = environment.apiKey

// 上市企业列表查询
function geListedCompanyList (paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj)
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        token: token,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })
    return getListedCompanyListAPI(params)
}

export {geListedCompanyList}



// WEBPACK FOOTER //
// ./src/request/index/listedCompany.js